document.addEventListener("alpine:init", () => {
  Alpine.data("easterBackdrop2026", () => ({
    init() {
      // console.log("easterBackdrop2026");
      this.$nextTick(() => {
        this.initSwiper();
        this.initBlock7();
        this.initBlock6();

        // // 等待 Swiper 库加载完成
        // if (typeof Swiper !== "undefined") {
        //   this.initSwiper();
        // } else {
        //   // 如果 Swiper 还未加载，等待一段时间后重试
        //   setTimeout(() => {
        //     if (typeof Swiper !== "undefined") {
        //       this.initSwiper();
        //     }
        //   }, 100);
        // }
      });
    },

    // ============================================
    // Block2 - Swiper 轮播方法
    // ============================================
    swiper: null,
    canGoPrev: false,
    canGoNext: false,
    initSwiper() {
      const swiperEl = this.$refs.block2Swiper;
      if (!swiperEl) return;

      // Swiper 配置：触摸滚动，自动对齐到最近的卡片
      this.swiper = new Swiper(swiperEl, {
        slidesPerView: "auto",
        spaceBetween: 16,
        freeMode: false, // 禁用自由模式，使用 snap 对齐
        grabCursor: true, // 显示抓取光标
        touchEventsTarget: "container", // 触摸事件目标
        touchRatio: 1, // 触摸比例
        threshold: 5, // 触摸阈值
        speed: 300, // 切换速度
        resistance: true, // 边缘阻力
        resistanceRatio: 0.85, // 阻力比例
        watchOverflow: true, // 监听溢出
        breakpoints: {
          // 移动端
          0: {
            slidesPerView: 1.5,
            spaceBetween: 16,
          },
          // 平板
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          // 桌面
          1024: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
        },
        on: {
          init: () => {
            // 等待 Swiper 完全初始化并更新尺寸
            // 使用箭头函数保持 this 上下文
            const self = this;
            setTimeout(() => {
              if (self.swiper) {
                self.swiper.update();
                self.updateButtonStates();
              }
            }, 150);
          },
          slideChange: () => {
            this.updateButtonStates();
          },
          reachBeginning: () => {
            this.updateButtonStates();
          },
          reachEnd: () => {
            this.updateButtonStates();
          },
        },
      });

      // 等待图片加载完成后更新按钮状态
      this.waitForImagesLoaded(swiperEl).then(() => {
        if (this.swiper) {
          this.swiper.update();
          this.updateButtonStates();
        }
      });

      // 处理窗口大小变化
      let resizeTimer;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          if (this.swiper) {
            this.swiper.update();
            this.updateButtonStates();
          }
        }, 250);
      });
    },

    waitForImagesLoaded(container) {
      return new Promise((resolve) => {
        const images = container.querySelectorAll("img");
        if (images.length === 0) {
          resolve();
          return;
        }

        let loadedCount = 0;
        const totalImages = images.length;

        const checkComplete = () => {
          loadedCount++;
          if (loadedCount === totalImages) {
            resolve();
          }
        };

        images.forEach((img) => {
          if (img.complete) {
            checkComplete();
          } else {
            img.addEventListener("load", checkComplete);
            img.addEventListener("error", checkComplete);
          }
        });

        // 设置超时，避免某些图片永远不加载
        setTimeout(() => {
          resolve();
        }, 3000);
      });
    },

    updateButtonStates() {
      if (!this.swiper) return;

      // 检查是否可以滚动
      const isBeginning = this.swiper.isBeginning;
      const isEnd = this.swiper.isEnd;
      const slidesLength = this.swiper.slides.length;

      // 如果内容不足以滚动，禁用两个按钮
      if (slidesLength <= 1 || this.swiper.isLocked) {
        this.canGoPrev = false;
        this.canGoNext = false;
      } else {
        this.canGoPrev = !isBeginning;
        this.canGoNext = !isEnd;
      }
    },

    slidePrev() {
      if (this.swiper && this.canGoPrev) {
        this.swiper.slidePrev();
      }
    },

    slideNext() {
      if (this.swiper && this.canGoNext) {
        this.swiper.slideNext();
      }
    },

    // ============================================
    // Block6 - 抖动动画方法
    // ============================================
    block6IsAnimating: false,
    block6Observer: null,
    handleBlock6ImageClick() {
      // 获取当前 URL，移除可能存在的旧 hash，然后添加 #smile-home
      const currentUrl = window.location.href.split("#")[0];
      window.location.href = currentUrl + "#smile-home";
    },

    initBlock6() {
      const block6ImageWrapper = this.$el.querySelector("[data-block6-image]");
      if (!block6ImageWrapper) return;

      const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.3, // 当30%的图片进入视口时触发
      };

      const triggerShake = (target) => {
        if (this.block6IsAnimating) return;
        this.block6IsAnimating = true;

        // 移除之前的动画类，以便重新触发
        target.classList.remove("animate-shake");
        // 使用 requestAnimationFrame 确保类被移除后再添加
        requestAnimationFrame(() => {
          target.classList.add("animate-shake");
          // 动画结束后重置标志
          setTimeout(() => {
            this.block6IsAnimating = false;
          }, 600); // 动画持续时间
        });
      };

      this.block6Observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            triggerShake(entry.target);
          }
        });
      }, observerOptions);

      this.block6Observer.observe(block6ImageWrapper);
    },

    // ============================================
    // Block7 - 元素迁移方法
    // ============================================
    block7PollCount: 0,
    block7MaxPollAttempts: 10,
    initBlock7() {
      const elementId = this.$el.querySelector("[data-block7-element-id]")?.getAttribute("data-block7-element-id");
      if (!elementId || elementId.trim() === "") {
        return;
      }

      this.block7PollCount = 0;
      this.pollForElement(elementId);
    },

    pollForElement(elementId) {
      if (this.block7PollCount >= this.block7MaxPollAttempts) {
        console.warn(`Block7: 无法找到元素 #${elementId}，已达到最大查询次数`);
        return;
      }

      this.block7PollCount++;

      const element = document.getElementById(elementId);
      if (element) {
        // 找到元素，迁移到Block7容器中
        this.migrateElement(element);
      } else {
        // 未找到元素，继续轮询
        setTimeout(() => {
          this.pollForElement(elementId);
        }, 500); // 每500ms查询一次
      }
    },

    migrateElement(element) {
      const contentContainer = this.$refs.block7Content;
      if (!contentContainer) {
        console.error("Block7: 找不到内容容器");
        return;
      }

      // 移动元素到Block7容器中
      try {
        // 清空容器
        contentContainer.innerHTML = "";

        // 直接移动元素（不是克隆）
        contentContainer.appendChild(element);

        console.log(`Block7: 成功迁移元素 #${element.id} 到Block7模块`);
      } catch (error) {
        console.error("Block7: 迁移元素时出错", error);
      }
    },

    // ============================================
    // 生命周期方法
    // ============================================
    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      if (this.block6Observer) {
        this.block6Observer.disconnect();
        this.block6Observer = null;
      }
    },
  }));
});
